import { agreeLegalsClear, clearCartProducts, clearDataUser, clearGamificacion, clearUpdatedUserData, clearVentasMes, resetCancelAccount, resetCancelaPedidos, resetEcommerceConfig, resetGetmTienda, resetNotifications, resetObtienePedidos, resetProducts, resetPromosEcommerce, resetReadNotification, resetSendCart, resetSendOrder } from "./actions";

// ? Acciones que se deben ejecutar al cerrar sesión
export const CLEAR_ACTIONS = () => [
    clearDataUser(),
    resetCancelAccount(),
    clearVentasMes(),
    agreeLegalsClear(),
    clearUpdatedUserData(),
    clearGamificacion(),
    resetProducts(),
    clearCartProducts(),
    resetPromosEcommerce(),
    resetSendCart(),
    resetSendOrder(),
    resetObtienePedidos(),
    resetCancelaPedidos(),
    resetEcommerceConfig(),
    resetNotifications(),
    resetReadNotification(),
    resetGetmTienda(),
];